const KITCHENS_TABLE_READY = "kitchens-table-ready"
const SEARCH_TEXT_STATE = "kitchens-table-search-text-state"
const ROWS_PER_PAGE_STATE = "kitchens-table-rows-per-page-state"
const PAGINATION_STATE = "kitchens-table-pagination-state"

const KITCHEN_ID_FOR_ACTION = "kitchens-table-kitchen-id-for-action"

const ADD_EDIT_KITCHEN_READY = "add-edit-kitchen-ready"
const VIEW_KITCHEN_TEAM_TABLE_READY = "view-kitchen-team-table-ready"

const PREVIOUS_KITCHEN_FILTER_CLUSTER = "previous-kitchen-filter-cluster"
const PREVIOUS_KITCHEN_FILTER_CITY = "previous-kitchen-filter-city"


const VIEW_TEAM_ROWS_PER_PAGE_STATE = "kitchens-view-team-rows-per-page-state"
const VIEW_TEAM_PAGINATION_STATE = "kitchens-view-team-pagination-state"





const initialState = {
    isKitchensTableReady: true,
    kitchens: {},
    isAddEditKitchenReady:true,
    isViewKitchenTeamTableReady:true,
    
    kitchenSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousViewTeamRowsPerPageValue: 15,

    previousPaginationValue: 1,
    previousViewTeamPaginationValue: 1,


    previousKitchenFilterCity: "",
    previousKitchenFilterCluster: "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case KITCHENS_TABLE_READY:
            return Object.assign({}, state, { isKitchensTableReady: action.payload })
        case ADD_EDIT_KITCHEN_READY:
            return Object.assign({}, state, { isAddEditKitchenReady: action.payload })
        case VIEW_KITCHEN_TEAM_TABLE_READY:
            return Object.assign({}, state, { isViewKitchenTeamTableReady: action.payload })

        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case VIEW_TEAM_ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousViewTeamRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)

        case VIEW_TEAM_PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousViewTeamPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case KITCHEN_ID_FOR_ACTION:
            return Object.assign({}, state, {kitchenSelectedId:action.payload})
        case PREVIOUS_KITCHEN_FILTER_CLUSTER:
            return Object.assign({}, state, {previousKitchenFilterCluster:action.payload})
        case PREVIOUS_KITCHEN_FILTER_CITY:
            return Object.assign({}, state, {previousKitchenFilterCity:action.payload})



        default:
        return state
    
    }

}

export function kitchenTableReady(data) {
    return {
        type: KITCHENS_TABLE_READY,
        payload: data
    }
}


export function addEditKitchenReady(data) {
    return {
        type: ADD_EDIT_KITCHEN_READY,
        payload: data
    }
}

export function viewKitchenTeamTableReady(data) {
    return {
        type: VIEW_KITCHEN_TEAM_TABLE_READY,
        payload: data
    }
}




export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}


export function rowsViewTeamPerPageState(rows){
    return {
        type:VIEW_TEAM_ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationViewTeamState(pageNo){
    return{
        type:VIEW_TEAM_PAGINATION_STATE,
        payload:pageNo
    }
}

export function kitchenIdForAction(kitchenId){
    return{
        type:KITCHEN_ID_FOR_ACTION,
        payload:kitchenId
    }
}


export function previousKitchenFilterCity(filterVal){
    return{
        type:PREVIOUS_KITCHEN_FILTER_CITY,
        payload:filterVal
    }
}


export function previousKitchenFilterCluster(filterVal){
    return{
        type:PREVIOUS_KITCHEN_FILTER_CLUSTER,
        payload:filterVal
    }
}







// WEBPACK FOOTER //
// ./src/modules/Kitchens/redux/kitchens.js